'use client';

import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useMediaQuery } from '@eliadmin/core/src/hooks/use-media-query';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';
import { useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { FiLock, FiUser } from 'react-icons/fi';

type HeaderProfileButtonProps = {
  className?: {
    profile?: string;
  };
  order?: number;
};

export const HeaderProfileButton = ({ className, order }: HeaderProfileButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const { t } = useTranslations();

  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  const supportsHover = useMediaQuery('(hover: hover)');

  return (
    <>
      {me ? (
        <Link
          prefetch={false}
          href={ROUTES.PROFILE()}
          aria-label={locale.startsWith('cs') ? 'Můj účet' : 'Môj účet'}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-border hover:bg-neutral-50 sm:h-[44px] sm:w-[44px]"
        >
          <FaUser className="h-[18px] w-[18px] text-foreground sm:h-5 sm:w-5" />
        </Link>
      ) : (
        <button
          type="button"
          onClick={handleSignInClick}
          className="flex h-10 w-auto cursor-pointer items-center justify-center gap-2 rounded-full border border-border px-4 text-sm font-normal text-foreground hover:bg-neutral-50 sm:h-[44px] sm:w-auto"
        >
          <FaUser className="h-[18px] w-[18px] text-foreground sm:h-5 sm:w-5" /> {t('text190')}
        </button>
      )}
    </>
  );
};
